const EXPORT_PDF_FEATURE_FLAG = 'experiment-show-pdf-export-button-in-v-4'
const SCHEDULED_REPORT_BUTTON_FLAG = 'experiment-show-scheduled-report-button-in-v-4'
const EDIT_REDIRECT_FEATURE_FLAG = 'experiment-edit-redirect-in-v-4'
const DELETE_COPY_FEATURE_FLAG = 'experiment-v-4-dashboard-delete-copy'
const GENERATE_VISUALIZATION_LINK_FEATURE_FLAG = 'experiment-generate-viz-service-link'
const LLM_WORDCLOUD_FEATURE_FLAG = 'experiment-llm-wordcloud-in-v-4'

export {
  EXPORT_PDF_FEATURE_FLAG,
  SCHEDULED_REPORT_BUTTON_FLAG,
  EDIT_REDIRECT_FEATURE_FLAG,
  DELETE_COPY_FEATURE_FLAG,
  GENERATE_VISUALIZATION_LINK_FEATURE_FLAG,
  LLM_WORDCLOUD_FEATURE_FLAG
}
